module.exports = __webpack_public_path__ + "img/add.4e979734.png";